<template>
<div class="page_pay">
	<!-- 绑微信提醒 -->
    <div class="wechat_tips" v-if="!bindWX" @click="bandwechat" style="padding-left:.53rem">
        <div class="tips_left">请绑定微信</div>
        <div class="tips_right">
            <img :src="publicPath+'statics/images/weixin-2.png'" alt="" class="icon_wechat">
            <img :src="publicPath+'statics/images/icon_right_grey.png'" alt="" class="icon_right">
        </div>
    </div>
	<!-- 订单信息 -->
    <div class="order">
        <div class="order_tips">订单已提交</div>
        <div class="order_number">支付订单号：{{ pay_order_num }}</div>
    </div>
	<!-- 支付方式 -->
	<div class="payList">
        <van-checkbox-group v-model="checkedPay" @change="changeCheckedPay">
            <van-cell-group>
                <van-cell class="item" v-for="(item,index) in payMent" :key="index">
                    <template #title>
                        <img :src="item.icon" alt="" class="tu">
                        <span class="title">{{item.name}}{{item.id == 2 ?' (可用余额：￥'+useraccount.user_money+')': ''}}</span>
                    </template>
                    <template #right-icon>
                        <van-checkbox :name="item.id" :disabled="item.status ? false : true">
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon">
                            </template>
                        </van-checkbox>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-checkbox-group>
		<!-- 次卡列表 -->
		<van-radio-group class="samrtpay" v-if="checkedPay.indexOf(3) != -1" v-model="user_times_card_id">
			<van-cell-group>
				<van-cell class="item" clickable v-for="card in cardList" :key="card.id">
					<template #title>
						<span class="custom-title">{{card.times_card.name}}</span>
						<span class="custom-title">{{'(剩余'+ (card.times - card.used_times) +'次)'}}</span>
					</template>
					<template #right-icon>
						<van-radio :name="card.id" checked-color="#D34444"/>
					</template>
				</van-cell>
			</van-cell-group>
		</van-radio-group>
		<!-- <van-checkbox-group v-if="checkedPay.indexOf(3) != -1" max="1" v-model="user_times_card_id">
            <van-cell-group>
                <van-cell class="item" v-for="card in cardList" :key="card.id">
                    <template #title>
                        <span class="title">{{card.times_card.name}}</span>
                    </template>
                    <template #right-icon>
                        <van-checkbox :name="card.id">
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon">
                            </template>
                        </van-checkbox>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-checkbox-group> -->
    </div>
	<!-- 支付 -->
    <div class="action">
        <div class="pay" @click="tijiao">立即支付¥{{ price }}</div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smartpark-pay",
    data() {
        return {
            publicPath: process.env.BASE_URL,
			bindWX: false, // 判断用户是否绑定微信,用于提醒去绑微信才可微信支付
			pay_order_num: null, // 支付订单号
			order_sn: null,// 订单号
			useraccount: null,
			cardList: null,
			checkedPay: [], // 支付方式
			payMent: [],
			activeIcon: process.env.BASE_URL + 'statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
			activeIcon_plat: process.env.BASE_URL + 'statics/images/active_square.png',
            inactiveIcon_plat: process.env.BASE_URL + 'statics/images/inactive_square.png',
			price: null, // 支付金额
			is_timescard: this.$route.query.is_timescard, // 是否为购买次卡的订单 1是 null否
			user_times_card_id: null, // 次卡id
			params:{}
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
		this.pay_order_num = this.$route.query.pay_order_num
		this.order_sn = this.$route.query.order_sn
		console.log('订单号===',this.order_sn)
		this.price = this.$route.query.price
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '支付',
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
						this.getUserData()
						// 支付信息
						
						// 用户当前订单的票务信息
						this.userTicket = JSON.parse(localStorage.getItem('userTicket'))
						if(this.userTicket){
							this.getCardList()
						}
                    } else {
                        this.token = "";
                    }
                    // 调用某方法
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
			// 用户信息
        	this.getUserData()
			// 支付信息
			this.pay_order_num = this.$route.query.pay_order_num
			this.order_sn = this.$route.query.order_sn
			console.log('订单号===',this.order_sn)
			this.price = this.$route.query.price
			// 用户当前订单的票务信息
			this.userTicket = JSON.parse(localStorage.getItem('userTicket'))
			if(this.userTicket){
				this.getCardList()
			}
        }
		
    },
	mounted() {
	},
    methods: {
		// 绑定微信
        bandwechat() {
			// this.showPayTips = false // 绑微信,不给未支付提醒
            this.$router.push({
                path: '/set/account'
            })
		},
		// 获取用户信息
		getUserData() {
			var that = this
            if (that.token == null) {
                return
            }
            var params = {
                token: that.token
            }
            that.$api.user.index(params).then(res => {
                if (res.code == 200) {
                    that.useraccount = res.result.info.useraccount
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        if (res.result.info.users.app_openid && res.result.info.users.app_openid != undefined && res.result.info.users.app_openid != '') {
                            this.bindWX = true
                        } else {
                            this.bindWX = false
                        }
                    } else {
                        if (res.result.info.users.openid && res.result.info.users.openid != undefined && res.result.info.users.openid != '') {
                            this.bindWX = true
                        } else {
                            this.bindWX = false
                        }
                    }
                    that.setPaytype()
                }
            })
        },
		// 获取用户当前的次卡
		getCardList(){
			var that = this
			var params = {
				token: that.token,
				venue_id: that.userTicket.venue_id,
				smarkpark_id: that.userTicket.smarkpark_id,
				is_through_ticket: that.userTicket.is_through_ticket,
				ticket_id: that.userTicket.id
			}
			that.$api.smartpark.setinfo(params).then(res=>{
				if(res.code == 200){
					// 次卡
					that.cardList = res.result.user_times_card
					that.setPaytype()
					// console.log('我有次卡吗=====',that.cardList)
				}
			})
			// that.cardList = [
			// 	{
			// 		id: 1,
			// 		times: 10,  //总可用次数
        	// 		used_times: 0, //已用次数
			// 		times_card: {
			// 			name: '10次卡'
			// 		}
			// 	},
			// 	{
			// 		id: 2,
			// 		times: 10,  //总可用次数
        	// 		used_times: 3, //已用次数
			// 		times_card: {
			// 			name: '20次卡'
			// 		}
			// 	},
			// ]
		},
		// 设置支付方式
		setPaytype(){
			var that = this
			var pay = []
			// 微信
			pay.push({
				id: 1,
				name: '微信支付',
				pay: 'weixin',
				icon: process.env.BASE_URL + 'statics/images/shop/icon_wechat.png',
				status: 1
			})
			// 余额大于0
			if (that.useraccount && that.useraccount.user_money > 0) {
				pay.push({
					id: 2,
					name: '余额',
					pay: 'yue',
					icon: process.env.BASE_URL + 'statics/images/shop/icon_balance.png',
					status: 1
				})
			}
            // 购票订单 支持微信、余额和次卡支付 ; 购卡订单只支持微信、余额
			if(!that.is_timescard){
				if (that.cardList && that.cardList.length != 0) {
					pay.push({
						id: 3,
						name: '次卡',
						pay: 'cika',
						icon: process.env.BASE_URL + 'statics/images/shop/icon_charge.png',
						status: 1
					})
				}
			}            
            that.payMent = pay
			console.log('支付方式=====',that.payMent)
		},
		// 勾选支付方式
		changeCheckedPay(){
			var that = this
			// 未选次卡时,将次卡id清除掉
			if(that.checkedPay.indexOf(3) == -1){
				that.user_times_card_id = null
			}
		},
		// 提交
		tijiao(){
			var that = this
			var params = {
				token: that.token,
				pay_order_num: that.pay_order_num
			}
			var user_money = that.useraccount.user_money
			var money = 0
			// 未选择支付方式
			if(that.checkedPay.length == 0){
				that.$toast('请选择支付方式')
				return
			}else{
				// 余额付
				if(that.checkedPay.indexOf(2) != -1){
					if(parseFloat(user_money) >= parseFloat(that.price)){
						money = parseFloat(that.price)
					}else{
						money = parseFloat(user_money)
					}
					params.used_money = money
				}
				// 微信付
				if(that.checkedPay.indexOf(1) != -1){
					params.pay = 'weixin'
				} else {
					params.pay = ''
				}
				// 次卡付
				if(that.checkedPay.indexOf(3) != -1){
					if(!that.user_times_card_id){
						that.$toast('请选择您的次卡')
						return
					}else{
						params.user_times_card_id = that.user_times_card_id
					}
				}
			}
			if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                params.tag = 1
            }
			// console.log('参数====',params)
			// return
			that.params = params
			that.$api.smartpark.pay(params).then(res=>{
				if(res.code == 200){
					if(that.params.pay && that.params.pay!=undefined && that.params.pay == 'weixin'){
						if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                            if (res.result.config == null || res.result.config == undefined) {
                                that.$toast(res.result)
                                return
                            }
                            var p = res.result.config
                            p.url = that.$publicData.clientUrl + '/smartpark/paysuccess?order_sn='+that.order_sn+'&is_timescard='+that.is_timescard
                            var params = {
                                'data': p
                            }
                            this.$bridge.callhandler('sdjy://public/wxPay', params, (data) => {
                                    
                            })
                            return
                        }
						var data = res.result
						wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
							appId: data.config.appId, // 必填，公众号的唯一标识
							timestamp: data.config.timeStamp, // 必填，生成签名的时间戳
							nonceStr: data.config.nonceStr, // 必填，生成签名的随机串
							signature: data.config.paySign, // 必填，签名，见附录1
							jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
						});
						// 配置失败返回
						wx.error(function (res) {
							console.log('error')
							console.log(res)
							// that.$toast("微信支付配置失败！");
						});
						wx.ready(function () {
							// 调起微信支付
							wx.chooseWXPay({
								timestamp: data.config.timeStamp,
								nonceStr: data.config.nonceStr,
								package: data.config.package,
								signType: data.config.signType,
								paySign: data.config.paySign, // 支付签名
								success: function (res) {
									console.log('success')
									console.log(res)
									// 购票订单,支付成功后,移除参观者和用户购票信息
									if(!that.is_timescard){
										localStorage.removeItem('visitorList')
										localStorage.removeItem('userTicket')
									}
									// 支付成功
									if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
										var params = {
											'data': {
												'url': that.$publicData.clientUrl + '/smartpark/paysuccess?order_sn='+that.order_sn+'&is_timescard='+that.is_timescard
											}
										}
										that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

										})
									} else {
										that.$router.push({
											path: '/smartpark/paysuccess',
											query: {
												order_sn: that.order_sn, // 订单号
												is_timescard: that.is_timescard
											}
										})
									}
								},
								error: function (res) {

								},
								cancel: function (res) {

								}
							});
						});
					}else{
						// 支付成功后,移除参观者和用户购票信息
						localStorage.removeItem('visitorList')
						localStorage.removeItem('userTicket')
						// 跳转支付成功页
						if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                                var params = {
                                    'data': {
                                        'url': this.$publicData.clientUrl + '/smartpark/paysuccess?order_sn='+that.order_sn+'&is_timescard='+that.is_timescard
                                    }
                                }
                                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                                })
                            } else {
                                that.$router.push({
									path: '/smartpark/paysuccess',
									query: {
										order_sn: that.order_sn, // 订单号
										is_timescard: that.is_timescard
									}
								})
                            }
						
					}
				}else{
					that.$toast(res.message)
				}
			})
		}
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
